/**
 * frontend/src/modules/search/api.ts
 * PHASE 3.2 F2 — Appel API recherche globale.
 */

import { apiClient } from '@/lib/apiClient'
import type { SearchResponse } from './types'

export async function fetchSearch(q: string): Promise<SearchResponse> {
  const params = new URLSearchParams({ q })
  const response = await apiClient.get<SearchResponse>(`/search?${params}`)
  return response.data
}
